import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { ButtonStyleGreen } from "./Styles"

const StyledLink = styled(Link)`
  ${ButtonStyleGreen}
`;

const ButtonGreen = ({children, to}) => {
  return (
    <StyledLink to={to}>
      {children}
    </StyledLink>
  );
};

ButtonGreen.propTypes = {
  to: PropTypes.string.isRequired
};

export default ButtonGreen;
